import { dialog } from "../../../../nq-component";
import React, { useState } from "react";

function DialogConfirmation({ handleConfirm, confirmationType }) {
  return (
    <>
      <div className="p-4">
        <div className="d-flex align-items-center gap-3">
          <div className="align-self-start">
            <i
              class="rounded bi bi-question-circle fs-2 px-2 py-1"
              style={{ backgroundColor: "#F5F5F5", color: "#D18237" }}
            ></i>
          </div>
          <div className="d-flex flex-column mt-2">
            <h5 className="fw-bold" style={{ color: "#D18237" }}>
              {confirmationType === "approve" ? "Approve " : "Reject "}
              Request
            </h5>
            <div className="me-1 ms-2">
              <p className="mt-2">
                <span className="text-muted">
                  {`Are you sure you want to ${confirmationType} this request?`}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mb-3">
        <>
          <>
            <button
              className="btn"
              style={{ backgroundColor: "#e8ecf3" }}
              onClick={() => dialog.close()}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn text-white ms-2"
              style={{ backgroundColor: "#D18237" }}
              onClick={handleConfirm}
            >
              Confirm
            </button>
          </>
        </>
      </div>
    </>
  );
}

export default DialogConfirmation;
